<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <i class="el-icon-user"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">总用户数</div>
              <div class="card-panel-num">{{ statistics.currentPeriod && statistics.currentPeriod.totalUserCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-message">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">活跃客服数</div>
              <div class="card-panel-num">{{ statistics.currentPeriod && statistics.currentPeriod.activeAgentCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">总会话数</div>
              <div class="card-panel-num">{{ statistics.currentPeriod && statistics.currentPeriod.totalConversations || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-money">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">解决率</div>
              <div class="card-panel-num">{{ statistics.currentPeriod && statistics.currentPeriod.resolutionRate ? statistics.currentPeriod.resolutionRate.toFixed(1) + '%' : '0%' }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-cpu">
              <i class="el-icon-cpu"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">CPU使用率</div>
              <div class="card-panel-num">{{ realtimeStats.cpuUsage || 0 }}%</div>
              <div class="card-panel-sub">&nbsp;</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-memory">
              <i class="el-icon-coin"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">内存使用率</div>
              <div class="card-panel-num">{{ realtimeStats.memoryUsage || 0 }}%</div>
              <div class="card-panel-sub">{{ formatMemory(realtimeStats.memoryUsed) }} / {{ formatMemory(realtimeStats.memoryTotal) }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-connection">
              <i class="el-icon-connection"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">WS连接数</div>
              <div class="card-panel-num">{{ realtimeStats.websocketConnections || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-online">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">在线客服/用户</div>
              <div class="card-panel-num">{{ realtimeStats.onlineAgents || 0 }}/{{ realtimeStats.onlineUsers || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>CPU & 内存使用率</span>
          </div>
          <div id="resourceChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>网络流量</span>
          </div>
          <div id="networkChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>消息统计（每分钟）</span>
          </div>
          <div id="messageChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>在线用户</span>
          </div>
          <div id="onlineChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>会话趋势</span>
          </div>
          <div id="conversationChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>客服排名</span>
          </div>
          <div id="agentRankChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getTenantStatistics, getConversationTrend, getAgentRanking } from '@/api/statistics'
import { getRecentStats, getRealtimeStats } from '@/api/systemStats'
import * as echarts from 'echarts'

export default {
  name: 'Dashboard',
  data() {
    return {
      statistics: {},
      realtimeStats: {},
      conversationChart: null,
      agentRankChart: null,
      resourceChart: null,
      messageChart: null,
      networkChart: null,
      onlineChart: null,
      statsData: [],
      refreshTimer: null
    }
  },
  mounted() {
    this.loadStatistics()
    this.initCharts()
    this.startAutoRefresh()
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    async loadStatistics() {
      try {
        const endDate = new Date().toISOString().split('T')[0]
        const startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]

        const res = await getTenantStatistics({
          startDate,
          endDate
        })
        this.statistics = res.data || {}
      } catch (error) {
        console.error(error)
      }
    },
    initCharts() {
      try {
        const conversationChartDom = document.getElementById('conversationChart')
        const agentRankChartDom = document.getElementById('agentRankChart')
        const resourceChartDom = document.getElementById('resourceChart')
        const messageChartDom = document.getElementById('messageChart')
        const networkChartDom = document.getElementById('networkChart')
        const onlineChartDom = document.getElementById('onlineChart')

        if (!conversationChartDom || !agentRankChartDom || !resourceChartDom || !messageChartDom || !networkChartDom || !onlineChartDom) {
          console.error('图表DOM元素不存在')
          return
        }

        this.conversationChart = echarts.init(conversationChartDom)
        this.agentRankChart = echarts.init(agentRankChartDom)
        this.resourceChart = echarts.init(resourceChartDom)
        this.messageChart = echarts.init(messageChartDom)
        this.networkChart = echarts.init(networkChartDom)
        this.onlineChart = echarts.init(onlineChartDom)

        this.loadConversationTrend()
        this.loadAgentRanking()
        this.loadSystemStats()
      } catch (error) {
        console.error('初始化图表失败:', error)
      }
    },
    startAutoRefresh() {
      // 立即加载一次实时数据
      this.loadRealtimeStats()
      this.loadSystemStats()
      // 然后定时刷新
      this.refreshTimer = setInterval(() => {
        this.loadRealtimeStats()
        this.loadSystemStats()
      }, 10000)
    },
    async loadRealtimeStats() {
      try {
        const res = await getRealtimeStats()
        if (res.data) {
          this.realtimeStats = {
            cpuUsage: res.data.cpuUsage || 0,
            memoryUsage: res.data.memoryUsage || 0,
            memoryUsed: res.data.memoryUsed || 0,
            memoryTotal: res.data.memoryTotal || 0,
            websocketConnections: res.data.websocketConnections || 0,
            onlineAgents: res.data.onlineAgents || 0,
            onlineUsers: res.data.onlineUsers || 0
          }
        }
      } catch (error) {
        console.error('加载实时统计失败:', error)
      }
    },
    async loadSystemStats() {
      try {
        const res = await getRecentStats(60)
        this.statsData = res.data || []
        
        this.updateResourceChart()
        this.updateMessageChart()
        this.updateNetworkChart()
        this.updateOnlineChart()
      } catch (error) {
        console.error('加载系统统计失败:', error)
      }
    },
    updateResourceChart() {
      const times = this.statsData.map(item => {
        const d = new Date(item.statTime)
        return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
      })
      // 确保数据是数字类型，处理 BigDecimal 返回的对象
      const cpuData = this.statsData.map(item => {
        const val = item.cpuUsage
        return typeof val === 'object' && val !== null ? parseFloat(val.value || val) : parseFloat(val || 0)
      })
      const memoryData = this.statsData.map(item => {
        const val = item.memoryUsage
        return typeof val === 'object' && val !== null ? parseFloat(val.value || val) : parseFloat(val || 0)
      })

      this.resourceChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['CPU', '内存']
        },
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: 'CPU',
            type: 'line',
            smooth: true,
            data: cpuData,
            itemStyle: { color: '#f4516c' }
          },
          {
            name: '内存',
            type: 'line',
            smooth: true,
            data: memoryData,
            itemStyle: { color: '#36a3f7' }
          }
        ]
      })
    },
    updateMessageChart() {
      const times = this.statsData.map(item => {
        const d = new Date(item.statTime)
        return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
      })
      const agentData = this.statsData.map(item => item.messageFromAgent)
      const userData = this.statsData.map(item => item.messageFromUser)

      this.messageChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['客服发送', '用户发送']
        },
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '客服发送',
            type: 'bar',
            data: agentData,
            itemStyle: { color: '#409eff' }  // 蓝色
          },
          {
            name: '用户发送',
            type: 'bar',
            data: userData,
            itemStyle: { color: '#f56c6c' }  // 红色
          }
        ]
      })
    },
    updateNetworkChart() {
      const times = this.statsData.map(item => {
        const d = new Date(item.statTime)
        return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
      })
      // 网络入站流量 (KB/s)
      const networkInData = this.statsData.map(item => {
        const val = item.networkIn || 0
        return typeof val === 'object' && val !== null ? parseFloat(val.value || val) : parseFloat(val || 0)
      })
      // 网络出站流量 (KB/s)
      const networkOutData = this.statsData.map(item => {
        const val = item.networkOut || 0
        return typeof val === 'object' && val !== null ? parseFloat(val.value || val) : parseFloat(val || 0)
      })

      this.networkChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let result = params[0].axisValue + '<br/>'
            params.forEach(param => {
              result += param.marker + param.seriesName + ': ' + (param.value / 1024).toFixed(2) + ' KB/s<br/>'
            })
            return result
          }
        },
        legend: {
          data: ['入站流量', '出站流量']
        },
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (val) => (val / 1024).toFixed(0) + ' KB/s'
          }
        },
        series: [
          {
            name: '入站流量',
            type: 'line',
            smooth: true,
            data: networkInData,
            itemStyle: { color: '#67c23a' },  // 绿色
            areaStyle: { opacity: 0.3 }
          },
          {
            name: '出站流量',
            type: 'line',
            smooth: true,
            data: networkOutData,
            itemStyle: { color: '#e6a23c' },  // 橙色
            areaStyle: { opacity: 0.3 }
          }
        ]
      })
    },
    updateOnlineChart() {
      const times = this.statsData.map(item => {
        const d = new Date(item.statTime)
        return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
      })
      const onlineAgentsData = this.statsData.map(item => item.onlineAgents || 0)
      const onlineUsersData = this.statsData.map(item => item.onlineUsers || 0)

      this.onlineChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['在线客服', '在线用户']
        },
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '在线客服',
            type: 'line',
            smooth: true,
            data: onlineAgentsData,
            itemStyle: { color: '#409eff' }  // 蓝色
          },
          {
            name: '在线用户',
            type: 'line',
            smooth: true,
            data: onlineUsersData,
            itemStyle: { color: '#67c23a' }  // 绿色
          }
        ]
      })
    },
    async loadConversationTrend() {
      try {
        const endDate = new Date().toISOString().split('T')[0]
        const startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]

        const res = await getConversationTrend({
          startDate,
          endDate,
          interval: 'day'
        })

        const data = res.data || {}

        this.conversationChart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: data.dates || []
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '会话数',
            data: data.conversationCounts || [],
            type: 'line',
            smooth: true
          }]
        })
      } catch (error) {
        console.error('加载会话趋势失败:', error)
        this.conversationChart.setOption({
          tooltip: { trigger: 'axis' },
          xAxis: { type: 'category', data: [] },
          yAxis: { type: 'value' },
          series: [{ data: [], type: 'line', smooth: true }]
        })
      }
    },
    async loadAgentRanking() {
      try {
        const endDate = new Date().toISOString().split('T')[0]
        const startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]

        const res = await getAgentRanking({
          startDate,
          endDate,
          sortBy: 'rating'
        })

        const data = res.data || []

        this.agentRankChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: data.map(item => item.agentName || '未知')
          },
          series: [{
            name: '评分',
            type: 'bar',
            data: data.map(item => item.avgRating || 0)
          }]
        })
      } catch (error) {
        console.error('加载客服排名失败:', error)
        this.agentRankChart.setOption({
          tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
          xAxis: { type: 'value' },
          yAxis: { type: 'category', data: [] },
          series: [{ type: 'bar', data: [] }]
        })
      }
    },
    formatMemory(bytes) {
      if (!bytes || bytes === 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      let i = 0
      let value = bytes
      while (value >= 1024 && i < units.length - 1) {
        value /= 1024
        i++
      }
      return Math.round(value * 100) / 100 + ' ' + units[i]
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  .box-card {
    cursor: pointer;
    
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      
      .icon-people {
        background: #40c9c6;
      }
      
      .icon-message {
        background: #36a3f7;
      }
      
      .icon-shopping {
        background: #f4516c;
      }
      
      .icon-money {
        background: #34bfa3;
      }
      
      .icon-cpu {
        background: #e6a23c;
      }
      
      .icon-memory {
        background: #909399;
      }
      
      .icon-connection {
        background: #67c23a;
      }
      
      .icon-online {
        background: #409eff;
      }
    }
    
    .card-panel {
      display: flex;
      align-items: center;
      
      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
        font-size: 48px;
        
        &.icon-people {
          color: #40c9c6;
        }
        
        &.icon-message {
          color: #36a3f7;
        }
        
        &.icon-shopping {
          color: #f4516c;
        }
        
        &.icon-money {
          color: #34bfa3;
        }
        
        &.icon-cpu {
          color: #e6a23c;
        }
        
        &.icon-memory {
          color: #909399;
        }
        
        &.icon-connection {
          color: #67c23a;
        }
        
        &.icon-online {
          color: #409eff;
        }
      }
      
      .card-panel-description {
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;
        
        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }
        
        .card-panel-num {
          font-size: 20px;
        }
        
        .card-panel-sub {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 4px;
        }
      }
    }
  }
}

.mt-20 {
  margin-top: 20px;
}
</style>
